import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CUSTOMER_CARE_NUMBER, WEBSITE_URL } from 'src/environments/environment';
import { MetaService } from 'src/services/meta-service.service';
import { ACTIVATION_ROUTE_URLS, SUPPORT_ROUTE_URLS, ROUTE_URLS, SHOP_ROUTE_URLS, PLANS_SHOP_ROUTE_URLS } from '../app.routes.names';
import { AppState } from 'src/app/app.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, OnDestroy {
  public jsonLDString: any;
  public innerWidth: any;
  public zipCode = '';
  public processingRequest = false;
  public customHtml;
  public isLoggedIn: boolean;
  public ROUTE_URLS = ROUTE_URLS;
  public SUPPORT_ROUTE_URLS = SUPPORT_ROUTE_URLS;
  public ACTIVATION_ROUTE_URLS = ACTIVATION_ROUTE_URLS;
  public isBannersSlidesReady = false;
  public page: any;
  public WEBSITE_URL = WEBSITE_URL;
  private alive = true;

   constructor(private router: Router,
               private metaService: MetaService,
               private appState: AppState) {

    this.prepareSchemaData();
    this.metaService.createCanonicalUrl(WEBSITE_URL);
    }

  ngOnInit(): void {
    this.innerWidth = window.innerWidth;
  }

  ngOnDestroy(): void {
    this.alive = false;
  }
  public goToPlans(expand20?: boolean): void {
    this.router.navigate([`${SHOP_ROUTE_URLS.BASE}/${SHOP_ROUTE_URLS.PLANS_AND_FEATURES}/${PLANS_SHOP_ROUTE_URLS.NEW_PLAN}`]);
  }

  public goToplanDetails(id): void {
    this.router.navigate([`${SHOP_ROUTE_URLS.BASE}/${SHOP_ROUTE_URLS.PLANS_AND_FEATURES}/${PLANS_SHOP_ROUTE_URLS.NEW_PLAN}`]);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event): void {
    this.innerWidth = window.innerWidth;
  }

  private prepareSchemaData(): void {
    const structuredData = {
      '@type': 'Organization',
      '@id': `${WEBSITE_URL}/#organization`,
      name: 'GoodMobile',
      url: WEBSITE_URL,
      logo: `${WEBSITE_URL}/assets/img/logo.svg`,
      contactPoint: [{
        '@type': 'ContactPoint',
        telephone: CUSTOMER_CARE_NUMBER,
        contactType: 'Customer Care',
        areaServed: 'US'
      }],
      sameAs: ['https://facebook.com/goodmobileusa', 'https://twitter.com/goodmobileusa', 'https://instagram.com/goodmobileusa']
    };
    this.jsonLDString = this.appState.setJsonLdData(structuredData);
  }
}
